/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CheckPointsData } from './CheckPointsData';
const CheckPointsExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('check_points')],
    ['data', CheckPointsData],
]);
export class CheckPointsExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CheckPointsExtraParser.decode(input).map(res => new CheckPointsExtra(res));
    }
    static unsafeDecode(input) {
        return CheckPointsExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CheckPointsExtraParser.encode(data);
    }
    static schema() {
        return CheckPointsExtraParser.schema();
    }
}
